import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";

export const PreparerChangeConfirm = ({
  isOpen,
  close,
  preparerName,
  onSubmit,
  isLoading,
}: ModalProps & {
  preparerName: string | undefined;
  onSubmit: () => void;
  isLoading?: boolean;
}) => {
  const confirmationText = preparerName ? (
    <>
      Are you sure you want to assign this task to <b>{preparerName}</b>?
    </>
  ) : (
    "Are you sure you want to unassign the preparer from this task?"
  );
  const action = preparerName ? "Assign" : "Unassign";
  const buttonType = preparerName ? "primary" : "danger";

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>{action} Preparer</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body className="t-text-body-sm">{confirmationText}</Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            customType={buttonType}
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onSubmit}
          >
            Yes
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
